module.exports = __webpack_public_path__ + "assets/functionalityCloseSmall-c5128f.svg";